import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import cookie from "../utils/useCookie";

export default function useAutomaticLogIn() {
  const navigate = useNavigate();

  useEffect(() => {
    const getToken = async () => {
      const access: any = await cookie.getCookie("ID_USER_ACCOUNT");

      if (access) {
        navigate("/admin")
      }
    };

    getToken();
  }, []);
}
